export function useUtil() {




const formatDatewSlashmmddyyyy = (isoString) => {
  const date = new Date(isoString);
  const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

const formatDatewDashyyyymmdd = (isoString) => {
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const formatDateWithDashNoTimezone = (isoString) => {
  return isoString.split('T')[0]; // returns 'YYYY-MM-DD' without timezone offset
};

const formatDateWithSlashesNoTimezone = (isoString) => {
  const [year, month, day] = isoString.split('T')[0].split('-');
  return `${month}/${day}/${year}`;
};

const getSlugPreview = (name, startdate) => {
  const baseSlug = name
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-')       
    .replace(/[^a-z0-9-]/g, '')    
    .replace(/--+/g, '-')          
    .replace(/^-+|-+$/g, '');      

  if (!startdate) return baseSlug;

  const [year, month, day] = startdate.split('-');
  const date = new Date(year, month - 1, day); // local timezone-safe

  const formattedDate = `${month}${day}${year}`;
  return `${baseSlug}-${formattedDate}`;
};


const toTitleCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .filter(Boolean)
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(' ');
};



  return {
    formatDatewSlashmmddyyyy,
    formatDatewDashyyyymmdd,
    formatDateWithSlashesNoTimezone,
    formatDateWithDashNoTimezone,
    getSlugPreview,
    toTitleCase,
  };
}
